import { observer } from 'mobx-react-lite'
import { ModalWindow } from 'src/component/common/analog/template/ModalWindow'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { AppButton } from 'src/component/common/analog/molecule/button/AppButton'
import { AppDivider } from 'src/component/common/analog/molecule/AppDivider'
import { Paragraph } from 'src/feature/localization/component/atom/Paragraph'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'

type DeletePerformanceReviewModalProps = {
  open: boolean
  templateName?: string
  onClose: () => void
  onConfirm: () => void
}

export const DeletePerformanceReviewModal = observer(({
  open,
  templateName,
  onClose,
  onConfirm,
}: DeletePerformanceReviewModalProps) => {
  const { translation } = useLocalizationStore()
  const performanceReviewTranslation = translation.pages.myTeam.performanceReview
  
  return (
    <ModalWindow
      modalProps={{
        open,
        onClose,
        PaperProps: {
          sx: {
            maxWidth: { xs: '80%', md: '50%', lg: '30%' },
            borderRadius: '10px',
          },
        },
      }}
      titleProps={{
        textValue: performanceReviewTranslation.deleteConfirmation(),
      }}
    >
      <AppBox sx={styles.content}>
        <Paragraph
          textValue={`${performanceReviewTranslation.deletePerformanceReview()}${templateName ? ` "${templateName}"` : ''}?`}
          m={5}
        />

        <AppDivider />

        <AppBox sx={styles.actions}>
          <AppButton
            fontSize={12}
            variant='light'
            onClick={onClose}
          >
            {performanceReviewTranslation.cancel()}
          </AppButton>

          <AppButton
            fontSize={12}
            variant='contained'
            onClick={onConfirm}
          >
            {performanceReviewTranslation.confirm()}
          </AppButton>
        </AppBox>
      </AppBox>
    </ModalWindow>
  )
})

const styles = {
  content: {
    flexDirection: 'column',
    gap: 10,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
  },
} as const